<!--<template>-->
<!--  <v-dialog-->
<!--    scrollable-->
<!--    v-model="visible"-->
<!--    max-width="900px"-->
<!--    :fullscreen="fullscreen"-->
<!--    :persistent="true"-->
<!--  >-->
<!--    <v-card>-->
<!--      <v-toolbar flat dense>-->
<!--        <v-toolbar-title class="subheading">查看</v-toolbar-title>-->

<!--        <v-spacer/>-->

<!--        <v-btn icon @click="fullscreen=!fullscreen">-->
<!--          <v-icon>fullscreen</v-icon>-->
<!--        </v-btn>-->
<!--      </v-toolbar>-->

<!--      <v-divider style="max-height: 1px"/>-->
<!--      <v-progress-linear class="my-0" :indeterminate="true" :active="loading" height="2"/>-->

<!--      <v-card-text>-->
<!--        <v-container grid-list-md>-->
<!--          <v-layout wrap>-->
<!--            <v-flex xs10>-->
<!--              <div class="x-text-field">-->
<!--                <label>合同项目名称</label>-->
<!--                <div>{{item.name}}</div>-->
<!--              </div>-->
<!--            </v-flex>-->

<!--            <v-flex xs2>-->
<!--              <div class="x-text-field">-->
<!--                <label>合同方</label>-->
<!--                <div>{{item.ctraSide === 'J' ? '甲方':'乙方'}}</div>-->
<!--              </div>-->
<!--            </v-flex>-->

<!--            <v-flex xs8>-->
<!--              <div class="x-text-field">-->
<!--                <label>合同相对方</label>-->
<!--                <div>{{item.ctraOrg}}</div>-->
<!--              </div>-->
<!--            </v-flex>-->

<!--            <v-flex xs4>-->
<!--              <div class="x-text-field">-->
<!--                <label>合同类型</label>-->
<!--                <div>{{item.types && item.types.length > 0 ? item.types[0].name : ''}}</div>-->
<!--              </div>-->
<!--            </v-flex>-->

<!--            <v-flex xs1>-->
<!--              <div class="x-text-field">-->
<!--                <label>经办人</label>-->
<!--                <div>{{item.agentName}}</div>-->
<!--              </div>-->
<!--            </v-flex>-->

<!--            <v-flex xs3>-->
<!--              <div class="x-text-field">-->
<!--                <label>承办单位</label>-->
<!--                <div>{{item.department ? item.department.name : ''}}</div>-->
<!--              </div>-->
<!--            </v-flex>-->

<!--            <v-flex xs8>-->
<!--              <div class="x-text-field">-->
<!--                <label>经费来源</label>-->
<!--                <div>{{item.fundSrc}}</div>-->
<!--              </div>-->
<!--            </v-flex>-->

<!--            <v-flex xs4>-->
<!--              <div class="x-text-field">-->
<!--                <label>项目经费号</label>-->
<!--                <div>{{item.fundNum}}</div>-->
<!--              </div>-->
<!--            </v-flex>-->

<!--            <v-flex xs4>-->
<!--              <div class="x-text-field">-->
<!--                <label>采购项目号</label>-->
<!--                <div>{{item.projNum}}</div>-->
<!--              </div>-->
<!--            </v-flex>-->

<!--            <v-flex xs4>-->
<!--              <div class="x-text-field">-->
<!--                <label>合同金额</label>-->
<!--                <div>{{item.amount}}</div>-->
<!--              </div>-->
<!--            </v-flex>-->

<!--            <v-flex xs4>-->
<!--              <div class="x-text-field">-->
<!--                <label>合同期限</label>-->
<!--                <div>{{item.period}}</div>-->
<!--              </div>-->
<!--            </v-flex>-->

<!--            <v-flex xs4>-->
<!--              <div class="x-text-field">-->
<!--                <label>签约人</label>-->
<!--                <div>{{item.signatory}}</div>-->
<!--              </div>-->
<!--            </v-flex>-->

<!--            <v-flex xs4>-->
<!--              <div class="x-text-field">-->
<!--                <label>联系电话</label>-->
<!--                <div>{{item.phone}}</div>-->
<!--              </div>-->
<!--            </v-flex>-->

<!--            <v-flex xs12>-->
<!--              <div class="x-text-field">-->
<!--                <label>合同标的（主要内容）</label>-->
<!--                <div>{{item.content}}</div>-->
<!--              </div>-->
<!--            </v-flex>-->

<!--            <v-flex xs3>-->
<!--              <div class="x-text-field">-->
<!--                <label>校章用印数</label>-->
<!--                <div>{{item.instSealNum}}</div>-->
<!--              </div>-->
<!--            </v-flex>-->

<!--            <v-flex xs3>-->
<!--              <div class="x-text-field">-->
<!--                <label>法人章用印数</label>-->
<!--                <div>{{item.corpSealNum}}</div>-->
<!--              </div>-->
<!--            </v-flex>-->

<!--            <v-flex xs3>-->
<!--              <div class="x-text-field">-->
<!--                <label>技术合同章用印数</label>-->
<!--                <div>{{item.techSealNum}}</div>-->
<!--              </div>-->
<!--            </v-flex>-->

<!--            <v-flex xs3>-->
<!--              <div class="x-text-field">-->
<!--                <label>授权委托人章用印数</label>-->
<!--                <div>{{item.prinSealNum}}</div>-->
<!--              </div>-->
<!--            </v-flex>-->

<!--            <v-flex xs12>-->
<!--              <div class="x-text-field">-->
<!--                <label>是否纳入学校统一招标，合同文本与招投标文件内容一致，合同签订单位、金额与招标结果一致</label>-->
<!--                <div>{{item.nrtyzb === "T" ? "是" : "否"}}</div>-->
<!--              </div>-->
<!--            </v-flex>-->

<!--            <v-flex xs12>-->
<!--              <div class="x-text-field">-->
<!--                <label>是否属于政府采购网上竞价（电商）采购项目，无中标通知书，合同模板为学校推荐文本</label>-->
<!--                <div>{{item.wsjj === "T" ? "是" : "否"}}</div>-->
<!--              </div>-->
<!--            </v-flex>-->

<!--            <v-flex xs12>-->
<!--              <div class="x-text-field">-->
<!--                <label>合同类别</label>-->
<!--                <div>{{item.cates && item.cates.length > 0 ? item.cates[0].name : ''}}</div>-->
<!--              </div>-->
<!--            </v-flex>-->

<!--            <v-flex xs6>-->
<!--              <div class="x-text-field">-->
<!--                <label>是否已使用格式合同范本</label>-->
<!--                <div>{{item.htfb === "T" ? "是" : "否"}}</div>-->
<!--              </div>-->
<!--            </v-flex>-->

<!--            <v-flex xs6>-->
<!--              <div class="x-text-field">-->
<!--                <label>是否已核查合同主体资质</label>-->
<!--                <div>{{item.htztzz === "T" ? "是" : "否"}}</div>-->
<!--              </div>-->
<!--            </v-flex>-->

<!--            <v-flex xs6>-->
<!--              <div class="x-text-field">-->
<!--                <label>是否已核查合同文本内容</label>-->
<!--                <div>{{item.htwbnr === "T" ? "是" : "否"}}</div>-->
<!--              </div>-->
<!--            </v-flex>-->

<!--            <v-flex xs6>-->
<!--              <div class="x-text-field">-->
<!--                <label>是否已核查法律风险条款</label>-->
<!--                <div>{{item.flfxtk === "T" ? "是" : "否"}}</div>-->
<!--              </div>-->
<!--            </v-flex>-->

<!--            <v-flex xs12>-->
<!--              <div class="x-text-field">-->
<!--                <label>是否纳入学校预算，符合学校开支范围</label>-->
<!--                <div>{{item.nrys === "T" ? "是" : "否"}}</div>-->
<!--              </div>-->
<!--            </v-flex>-->

<!--            <v-flex xs6>-->
<!--              <div class="x-text-field">-->
<!--                <label>合同订立的依据是否存在</label>-->
<!--                <div>{{item.dlyj === "T" ? "是" : "否"}}</div>-->
<!--              </div>-->
<!--            </v-flex>-->

<!--            <v-flex xs6>-->
<!--              <div class="x-text-field">-->
<!--                <label>合同当事人是否适格</label>-->
<!--                <div>{{item.dsrsh === "T" ? "是" : "否"}}</div>-->
<!--              </div>-->
<!--            </v-flex>-->

<!--            <v-flex xs6>-->
<!--              <div class="x-text-field">-->
<!--                <label>合同的签订材料是否完备齐全</label>-->
<!--                <div>{{item.clqb === "T" ? "是" : "否"}}</div>-->
<!--              </div>-->
<!--            </v-flex>-->

<!--            <v-flex xs6>-->
<!--              <div class="x-text-field">-->
<!--                <label>合同内容是否违反国家政策或者学校规定</label>-->
<!--                <div>{{item.wfgd === "T" ? "是" : "否"}}</div>-->
<!--              </div>-->
<!--            </v-flex>-->

<!--            <v-flex xs12>-->
<!--              <div class="x-text-field">-->
<!--                <label>是否采用格式合同范本或者是否对格式合同范本主要条款作实质性变更</label>-->
<!--                <div>{{item.cyhtfb === "T" ? "是" : "否"}}</div>-->
<!--              </div>-->
<!--            </v-flex>-->

<!--            <v-flex-->
<!--                xs12-->
<!--                v-if="item.attachments && item.attachments.length > 0"-->
<!--            >-->
<!--              <p class="my-1">附件列表：</p>-->
<!--              <v-divider/>-->
<!--              <ol>-->
<!--                <li v-for="a in item.attachments" :key="a.dbid" class="pt-1">-->
<!--                  <a :href="`/api/ctra/file/${a.dbid}`" target="_blank">-->
<!--                    {{a.fileName}}-->
<!--                    ({{a.size | fileSize }})-->
<!--                  </a>-->
<!--                </li>-->
<!--              </ol>-->
<!--            </v-flex>-->


<!--          </v-layout>-->
<!--        </v-container>-->
<!--      </v-card-text>-->

<!--      <v-card-actions>-->
<!--        <v-spacer/>-->
<!--        <v-btn color="primary" @click.native="visible=false">关闭</v-btn>-->
<!--      </v-card-actions>-->

<!--    </v-card>-->
<!--  </v-dialog>-->
<!--</template>-->

<template>
  <v-dialog
      scrollable
      v-model="visible"
      max-width="900px"
      :fullscreen="fullscreen"
      :persistent="true"
  >
    <v-card class="contract-view-dialog enhanced">
      <v-toolbar flat dense class="primary enhanced-toolbar">
        <v-toolbar-title class="subheading white--text font-weight-medium">
          <v-icon class="mr-2 white--text" small>description</v-icon>
          合同详情
        </v-toolbar-title>

        <v-spacer/>

        <v-btn icon @click="fullscreen=!fullscreen" class="white--text" small>
          <v-icon small>fullscreen</v-icon>
        </v-btn>
      </v-toolbar>

      <v-progress-linear
          class="my-0 accent"
          :indeterminate="true"
          :active="loading"
          height="2"
      />

      <v-card-text class="dialog-content enhanced-content pa-3">
        <v-container grid-list-md class="py-2 enhanced-container">
          <v-layout wrap class="enhanced-layout">
            <!-- 基本信息 -->
            <v-flex xs12 class="enhanced-section-header">
              <div class="enhanced-section-title primary--text text--darken-2">
                <v-icon class="mr-1" small>info</v-icon>
                基本信息
              </div>
            </v-flex>

            <v-flex xs7 class="enhanced-field">
              <div class="enhanced-text-field">
                <label class="enhanced-label">合同项目名称</label>
                <div class="enhanced-value emphasized">{{item.name}}</div>
              </div>
            </v-flex>

            <v-flex xs3 class="enhanced-field">
              <div class="enhanced-text-field">
                <label class="enhanced-label">合同相对方</label>
                <div class="enhanced-value emphasized">{{item.ctraOrg}}</div>
              </div>
            </v-flex>

            <v-flex xs2 class="enhanced-field">
              <div class="enhanced-text-field">
                <label class="enhanced-label">签约人</label>
                <div class="enhanced-value emphasized">{{item.signatory}}</div>
              </div>
            </v-flex>

            <v-flex xs2 class="enhanced-field">
              <div class="enhanced-text-field">
                <label class="enhanced-label">合同方</label>
                <div class="enhanced-value emphasized">{{item.ctraSide === 'J' ? '甲方':'乙方'}}</div>
              </div>
            </v-flex>

            <v-flex xs2 class="enhanced-field">
              <div class="enhanced-text-field">
                <label class="enhanced-label">合同类型</label>
                <div class="enhanced-value emphasized">{{item.types && item.types.length > 0 ? item.types[0].name : ''}}</div>
              </div>
            </v-flex>

            <v-flex xs2 class="enhanced-field">
              <div class="enhanced-text-field">
                <label class="enhanced-label">承办人</label>
                <div class="enhanced-value emphasized">{{item.agentName}}</div>
              </div>
            </v-flex>

            <v-flex xs6 class="enhanced-field">
              <div class="enhanced-text-field">
                <label class="enhanced-label">承办单位</label>
                <div class="enhanced-value emphasized">{{item.department ? item.department.name : ''}}</div>
              </div>
            </v-flex>



            <!-- 财务信息 -->
            <v-flex xs12 class="enhanced-section-header">
              <div class="enhanced-section-title primary--text text--darken-2">
                <v-icon class="mr-1" small>attach_money</v-icon>
                财务信息
              </div>
            </v-flex>

            <v-flex xs9 class="enhanced-field">
              <div class="enhanced-text-field">
                <label class="enhanced-label">经费来源</label>
                <div class="enhanced-value emphasized">{{item.fundSrc}}</div>
              </div>
            </v-flex>

            <v-flex xs3 class="enhanced-field">
              <div class="enhanced-text-field">
                <label class="enhanced-label">经费号</label>
                <div class="enhanced-value emphasized">{{item.fundNum}}</div>
              </div>
            </v-flex>

            <v-flex xs3 class="enhanced-field">
              <div class="enhanced-text-field">
                <label class="enhanced-label">采购号</label>
                <div class="enhanced-value emphasized">{{item.projNum}}</div>
              </div>
            </v-flex>

            <v-flex xs3 class="enhanced-field">
              <div class="enhanced-text-field">
                <label class="enhanced-label">合同金额</label>
                <div class="enhanced-value emphasized">{{item.amount}}</div>
              </div>
            </v-flex>

            <v-flex xs3 class="enhanced-field">
              <div class="enhanced-text-field">
                <label class="enhanced-label">合同期限</label>
                <div class="enhanced-value emphasized">{{item.period}}</div>
              </div>
            </v-flex>

            <v-flex xs3 class="enhanced-field">
              <div class="enhanced-text-field">
                <label class="enhanced-label">联系电话</label>
                <div class="enhanced-value emphasized">{{item.phone}}</div>
              </div>
            </v-flex>

            <!-- 合同内容 - 重点突出区域 -->
            <v-flex xs12 class="enhanced-section-header">
              <div class="enhanced-section-title primary--text text--darken-2">
                <v-icon class="mr-1" small>subject</v-icon>
                合同内容
              </div>
            </v-flex>

            <v-flex xs12 class="enhanced-field content-field">
              <div class="enhanced-text-field">
                <label class="enhanced-label content-label">合同标的（主要内容）</label>
                <div class="content-main-box">{{item.content}}</div>
              </div>
            </v-flex>

            <!-- 用印信息 -->
            <v-flex xs12 class="enhanced-section-header">
              <div class="enhanced-section-title primary--text text--darken-2">
                <v-icon class="mr-1" small>stamp</v-icon>
                用印信息
              </div>
            </v-flex>

            <v-flex xs3 class="enhanced-field">
              <div class="enhanced-text-field">
                <label class="enhanced-label">校章</label>
                <div class="enhanced-value emphasized">{{item.instSealNum}}</div>
              </div>
            </v-flex>

            <v-flex xs3 class="enhanced-field">
              <div class="enhanced-text-field">
                <label class="enhanced-label">法人章</label>
                <div class="enhanced-value emphasized">{{item.corpSealNum}}</div>
              </div>
            </v-flex>

            <v-flex xs3 class="enhanced-field">
              <div class="enhanced-text-field">
                <label class="enhanced-label">技术合同章</label>
                <div class="enhanced-value emphasized">{{item.techSealNum}}</div>
              </div>
            </v-flex>

            <v-flex xs3 class="enhanced-field">
              <div class="enhanced-text-field">
                <label class="enhanced-label">委托人章</label>
                <div class="enhanced-value emphasized">{{item.prinSealNum}}</div>
              </div>
            </v-flex>

            <!-- 合规性检查 -->
            <v-flex xs12 class="enhanced-section-header">
              <div class="enhanced-section-title primary--text text--darken-2">
                <v-icon class="mr-1" small>check_circle</v-icon>
                合规性检查
              </div>
            </v-flex>

            <!-- 第一行布尔字段 -->
            <v-flex xs12 class="enhanced-field">
              <div class="enhanced-text-field">
                <label class="enhanced-label">是否纳入学校统一招标，合同文本与招投标文件内容一致，合同签订单位、金额与招标结果一致</label>
                <div class="enhanced-value boolean-indicator" :class="item.nrtyzb === 'T' ? 'success--text' : 'error--text'">
                  {{item.nrtyzb === "T" ? "是" : "否"}}
                </div>
              </div>
            </v-flex>

            <v-flex xs12 class="enhanced-field">
              <div class="enhanced-text-field">
                <label class="enhanced-label">是否属于政府采购网上竞价（电商）采购项目，无中标通知书，合同模板为学校推荐文本</label>
                <div class="enhanced-value boolean-indicator" :class="item.wsjj === 'T' ? 'success--text' : 'error--text'">
                  {{item.wsjj === "T" ? "是" : "否"}}
                </div>
              </div>
            </v-flex>

            <v-flex xs3 class="enhanced-field">
              <div class="enhanced-text-field">
                <label class="enhanced-label">合同类别</label>
                <div class="enhanced-value emphasized">{{item.cates && item.cates.length > 0 ? item.cates[0].name : ''}}</div>
              </div>
            </v-flex>

            <!-- 第二行布尔字段 -->
            <v-flex xs3 class="enhanced-field">
              <div class="enhanced-text-field">
                <label class="enhanced-label">是否已使用格式合同范本</label>
                <div class="enhanced-value boolean-indicator" :class="item.htfb === 'T' ? 'success--text' : 'error--text'">
                  {{item.htfb === "T" ? "是" : "否"}}
                </div>
              </div>
            </v-flex>

            <v-flex xs3 class="enhanced-field">
              <div class="enhanced-text-field">
                <label class="enhanced-label">是否已核查合同主体资质</label>
                <div class="enhanced-value boolean-indicator" :class="item.htztzz === 'T' ? 'success--text' : 'error--text'">
                  {{item.htztzz === "T" ? "是" : "否"}}
                </div>
              </div>
            </v-flex>

            <v-flex xs3 class="enhanced-field">
              <div class="enhanced-text-field">
                <label class="enhanced-label">是否已核查合同文本内容</label>
                <div class="enhanced-value boolean-indicator" :class="item.htwbnr === 'T' ? 'success--text' : 'error--text'">
                  {{item.htwbnr === "T" ? "是" : "否"}}
                </div>
              </div>
            </v-flex>

            <v-flex xs3 class="enhanced-field">
              <div class="enhanced-text-field">
                <label class="enhanced-label">是否已核查法律风险条款</label>
                <div class="enhanced-value boolean-indicator" :class="item.flfxtk === 'T' ? 'success--text' : 'error--text'">
                  {{item.flfxtk === "T" ? "是" : "否"}}
                </div>
              </div>
            </v-flex>

            <!-- 第三行布尔字段 -->
            <v-flex xs3 class="enhanced-field">
              <div class="enhanced-text-field">
                <label class="enhanced-label">是否纳入学校预算，符合学校开支范围</label>
                <div class="enhanced-value boolean-indicator" :class="item.nrys === 'T' ? 'success--text' : 'error--text'">
                  {{item.nrys === "T" ? "是" : "否"}}
                </div>
              </div>
            </v-flex>

            <v-flex xs3 class="enhanced-field">
              <div class="enhanced-text-field">
                <label class="enhanced-label">合同订立的依据是否存在</label>
                <div class="enhanced-value boolean-indicator" :class="item.dlyj === 'T' ? 'success--text' : 'error--text'">
                  {{item.dlyj === "T" ? "是" : "否"}}
                </div>
              </div>
            </v-flex>

            <v-flex xs3 class="enhanced-field">
              <div class="enhanced-text-field">
                <label class="enhanced-label">合同当事人是否适格</label>
                <div class="enhanced-value boolean-indicator" :class="item.dsrsh === 'T' ? 'success--text' : 'error--text'">
                  {{item.dsrsh === "T" ? "是" : "否"}}
                </div>
              </div>
            </v-flex>

            <!-- 第四行布尔字段 -->
            <v-flex xs3 class="enhanced-field">
              <div class="enhanced-text-field">
                <label class="enhanced-label">合同的签订材料是否完备齐全</label>
                <div class="enhanced-value boolean-indicator" :class="item.clqb === 'T' ? 'success--text' : 'error--text'">
                  {{item.clqb === "T" ? "是" : "否"}}
                </div>
              </div>
            </v-flex>

            <v-flex xs3 class="enhanced-field">
              <div class="enhanced-text-field">
                <label class="enhanced-label">合同内容是否违反国家政策或者学校规定</label>
                <div class="enhanced-value boolean-indicator" :class="item.wfgd === 'T' ? 'success--text' : 'error--text'">
                  {{item.wfgd === "T" ? "是" : "否"}}
                </div>
              </div>
            </v-flex>

            <v-flex xs6 class="enhanced-field">
              <div class="enhanced-text-field">
                <label class="enhanced-label">是否采用格式合同范本或者是否对格式合同范本主要条款作实质性变更</label>
                <div class="enhanced-value boolean-indicator" :class="item.cyhtfb === 'T' ? 'success--text' : 'error--text'">
                  {{item.cyhtfb === "T" ? "是" : "否"}}
                </div>
              </div>
            </v-flex>

            <!-- 附件 -->
            <v-flex
                xs12
                v-if="item.attachments && item.attachments.length > 0"
                class="enhanced-field"
            >
              <div class="enhanced-text-field">
                <label class="enhanced-label">附件列表</label>
                <div class="enhanced-attachment-list">
                  <div v-for="a in item.attachments" :key="a.dbid" class="enhanced-attachment-item">
                    <v-icon class="primary--text mr-2" small>insert_drive_file</v-icon>
                    <a :href="`/api/ctra/file/${a.dbid}`" target="_blank" class="enhanced-attachment-link">
                      {{a.fileName}} <span class="file-size">({{a.size | fileSize }})</span>
                    </a>
                  </div>
                </div>
              </div>
            </v-flex>

          </v-layout>
        </v-container>
      </v-card-text>

      <v-card-actions class="enhanced-actions pa-3">
        <v-spacer/>
        <v-btn
            color="primary"
            @click.native="visible=false"
            class="enhanced-btn"
        >
          <v-icon class="mr-1" small>close</v-icon>
          关闭
        </v-btn>
      </v-card-actions>

    </v-card>
  </v-dialog>
</template>

<style scoped>
.contract-view-dialog.enhanced {
  border-radius: 6px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.enhanced-toolbar {
  min-height: 44px !important;
}

.dialog-content.enhanced-content {
  background-color: #f8fafc;
  max-height: 70vh;
  overflow-y: auto;
  padding: 16px;
}

.enhanced-container {
  padding: 0;
}

.enhanced-layout {
  margin: -6px;
}

.enhanced-section-header {
  margin: 12px 0 6px 0;
  padding: 0 6px;
  width: 100%;
}

.enhanced-section-title {
  font-size: 14px;
  font-weight: 600;
  padding: 6px 0;
  border-bottom: 2px solid #e3f2fd;
  display: flex;
  align-items: center;
}

.content-section .enhanced-section-title {
  border-bottom-color: #1976d2;
  background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%);
  color: white !important;
  padding: 8px 12px;
  margin: 0 -6px;
  border-radius: 4px;
}

.content-section .enhanced-section-title .v-icon {
  color: white !important;
}

.enhanced-field {
  padding: 4px 6px;
  margin-bottom: 2px;
}

.enhanced-text-field {
  margin-bottom: 0;
  padding: 3px 0;
}

.enhanced-label {
  font-size: 12px;
  color: #546e7a;
  font-weight: 500;
  margin-bottom: 2px;
  display: block;
  line-height: 1.3;
}

.enhanced-value {
  font-size: 15px;
  color: #263238;
  padding: 3px 0;
  min-height: 18px;
  word-break: break-word;
  line-height: 1.4;
}

.emphasized {
  font-weight: 600;
  color: #1565c0;
}

.amount-value {
  font-weight: 600;
  color: #d32f2f;
  font-size: 14px;
}

/* 重点突出内容区域 */
.content-field {
  margin: 8px 0 16px 0;
}

.content-label {
  font-size: 13px;
  font-weight: 600;
  color: #1976d2;
  margin-bottom: 6px;
}

.content-main-box {
  background: white;
  border: 2px solid #e3f2fd;
  border-radius: 6px;
  padding: 12px 16px;
  min-height: 120px;
  line-height: 1.6;
  font-size: 14px;
  color: #37474f;
  box-shadow: 0 2px 8px rgba(25, 118, 210, 0.1);
  white-space: pre-wrap;
  word-wrap: break-word;
}

.enhanced-boolean .enhanced-label {
  font-size: 11px;
  line-height: 1.2;
}

.boolean-indicator {
  font-weight: 600;
  font-size: 14px;
}

.enhanced-attachment-list {
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  padding: 8px;
}

.enhanced-attachment-item {
  padding: 6px 8px;
  border-bottom: 1px solid #f5f5f5;
  font-size: 13px;
  display: flex;
  align-items: center;
}

.enhanced-attachment-item:last-child {
  border-bottom: none;
}

.enhanced-attachment-link {
  color: #1976d2;
  text-decoration: none;
  font-size: 13px;
  display: flex;
  align-items: center;
}

.enhanced-attachment-link:hover {
  color: #0d47a1;
  text-decoration: underline;
}

.file-size {
  color: #757575;
  font-size: 11px;
  margin-left: 4px;
}

.enhanced-actions {
  border-top: 1px solid #e0e0e0;
  background: white;
  min-height: 52px;
}

.enhanced-btn {
  min-width: 80px;
  height: 36px;
  font-size: 13px;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(25, 118, 210, 0.2);
}

/* 增强滚动条 */
.dialog-content.enhanced-content::-webkit-scrollbar {
  width: 6px;
}

.dialog-content.enhanced-content::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.dialog-content.enhanced-content::-webkit-scrollbar-thumb {
  background: #1976d2;
  border-radius: 3px;
}

.dialog-content.enhanced-content::-webkit-scrollbar-thumb:hover {
  background: #1565c0;
}

/* 内容区域特殊样式 */
.content-main-box {
  background: linear-gradient(135deg, #ffffff 0%, #f8fbff 100%);
  border-left: 4px solid #1976d2;
}

.content-section {
  margin-top: 16px;
}
</style>


<script>
  import {mapGetters} from 'vuex'
  import mixin from '@/mixin'

  const baseUri = '/api/ol-ctra/contract';

  export default {
    mixins: [mixin.view(baseUri)],

    data() {
      return {
        fileUri: '/api/ol-ctra/file',

        item: {},

        properties: {
          "wt": '委托合同',
          "ww": '外委合同'
        },
      }
    },
    computed: {
      ...mapGetters(['funcIds']),
      clientLabel() {
        return this.item.property === 'ww' ? '受托单位' : '委托单位'
      }
    },
  }
</script>
